<template>
  <button
    class="a-button-the-modal-cancel-action"
    type="button"
    @click="$modal.closeModal"
  >
    <i class="far fa-times margin-right-xsmall"></i>{{ buttonCancelText }}
  </button>
</template>

<script>
export default {
  name: 'AtomButtonTheModalCancelAction',

  props: {
    cancelText: String
  },

  data () {
    return {
      buttonCancelText: this.cancelText.toLowerCase()
    }
  }
}
</script>
